"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DropDownPillMenu;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _precheckIcons = require("../utils/precheck-icons");
var _dropdownPillMenuItem = _interopRequireDefault(require("./dropdown-pill-menu-item"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @module DropDownPillMenu */

/* VENDOR */

/* PL */

const DropDownContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "DropDownContainer",
  class: "pc-dupzfxz"
});
const DropDown = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "DropDown",
  class: "pc-d17clf3b"
});

/**
 * DropDownPillMenu
 * @param {Object} props React props
 * @param {Array<Object>} props.options List of DropDownPillMenuItems
 * @param {number} props.ariaLabel aria label for select element
 * @returns {React.ReactElement} DropDownPillMenu component
 * @public
 */
function DropDownPillMenu({
  id,
  options = [],
  ariaLabel,
  defaultSelected = 0,
  onChange
}) {
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [selected, setSelected] = (0, _react.useState)(defaultSelected);
  const dropDownRef = (0, _react.useRef)();
  const closeHandler = (0, _react.useCallback)(() => {
    setIsOpen(false);
  }, []);
  const optionSelectionHandler = (0, _react.useCallback)(({
    target,
    keyCode
  }) => {
    if (target.role !== 'option' || !dropDownRef.current.contains(target)) {
      return;
    }
    if (!isOpen) {
      setIsOpen(true);
    } else {
      const ix = [...target?.parentElement?.childNodes].indexOf(target);
      setSelected(ix);
      closeHandler({
        target,
        keyCode
      });
      onChange(options[ix]);
    }
  }, [closeHandler, isOpen, options, onChange]);
  const focusHandler = (0, _react.useCallback)(({
    target,
    keyCode
  }) => {
    if (target.role !== 'option' || !dropDownRef.current.contains(target)) {
      return;
    }
    if (!isOpen) {
      setIsOpen(true);
    } else if (keyCode === _patternLibraryUtils.keyCodes.ARROW_DOWN) {
      target?.nextSibling?.focus();
    } else {
      target?.previousSibling?.focus();
    }
  }, [isOpen]);
  (0, _patternLibraryUtils.useEventListener)('mousedown', optionSelectionHandler);
  (0, _patternLibraryUtils.useKeyup)('ENTER', optionSelectionHandler);
  (0, _patternLibraryUtils.useKeyup)('SPACE', optionSelectionHandler);
  (0, _patternLibraryUtils.useKeydown)('ARROW_UP', focusHandler);
  (0, _patternLibraryUtils.useKeydown)('ARROW_DOWN', focusHandler);
  (0, _patternLibraryUtils.useKeydown)('ESCAPE', closeHandler);
  (0, _patternLibraryUtils.useClickOutside)(dropDownRef.current, closeHandler, 'mousedown');
  (0, _patternLibraryUtils.useKeyOutside)(dropDownRef.current, closeHandler);
  (0, _react.useEffect)(() => {
    setSelected(defaultSelected);
  }, [defaultSelected]);
  const trackingProps = _patternLibraryUtils.tracking.props(options[selected]._name, true, false);
  return /*#__PURE__*/_react.default.createElement(DropDownContainer, {
    "data-partial": "precheck"
  }, /*#__PURE__*/_react.default.createElement(DropDown, (0, _extends2.default)({
    id: `id-${id}`,
    "data-cy": "dropdown-pill-menu",
    ref: dropDownRef,
    "aria-label": ariaLabel,
    "aria-expanded": isOpen,
    role: "listbox",
    tabIndex: "-1",
    "data-selected-name": (0, _patternLibraryUtils.applySnakeCase)(options[selected]._name)
  }, trackingProps), options.map((option, ix) => {
    const isSelected = ix === selected;
    const show = isOpen || isSelected;
    return show && /*#__PURE__*/_react.default.createElement(_dropdownPillMenuItem.default, (0, _extends2.default)({
      key: `${ariaLabel}-${ix}`
    }, option, {
      icon: (0, _precheckIcons.getIcon)(isSelected, isOpen),
      a11yAttributes: {
        ['aria-setsize']: options.length,
        ['aria-posinset']: ix + 1,
        ['aria-selected']: isSelected,
        tabIndex: '0',
        role: 'option'
      }
    }));
  })));
}
DropDownPillMenu.propTypes = {
  id: _propTypes.default.string,
  options: _propTypes.default.array,
  ariaLabel: _propTypes.default.string,
  defaultSelected: _propTypes.default.number,
  onChange: _propTypes.default.func
};